import { useState } from "react";
import { useDatabase } from '../../hooks/useDatabase';
import moment from "moment";

import './experience.css';
import { Link } from "react-router-dom";

export default function Experience() {
    const db = useDatabase();

    const settings = {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: db.sections.experience.length,
        slidesToScroll: 1,
        rows: 2,
        centerPadding: "20px",

        responsive: [{
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                rows: 1,
                arrows: false
            }
        }]
    };

    var experienceItems = db.sections.experience.sort((a, b) => {
        const dateA = moment(a.startDate);
        const dateB = moment(b.startDate);

        return dateB.diff(dateA);
    });

    const [ selectedTab, setSelectedTab ] = useState(experienceItems[0].id);
    function changeTab(id: number) {
        setSelectedTab(id);
    }

    return (
        <section className="experience-panel light" id="experience">
            <div className="inner">
                <h2>Experience</h2>

                <div className="tabbed-content-panel">
                    <div className="tabs">
                        {experienceItems.map((v, i) => {
                            return <div className={"tab-item" + (selectedTab === v.id ? " selected" : "")} onClick={() => changeTab(v.id)} key={v.id}>
                                <h3>{v.title}</h3>
                                <p>{v.jobTitle}</p>
                            </div>
                        })}
                    </div>
                    <div className="tab-content">
                        {experienceItems.map((v, i) => {
                            return <div className={"tab-content-item" + (selectedTab === v.id ? " selected" : "")} key={v.id}>
                                <div className="cols span-2 experience-header">
                                    <div className="col">
                                        <div className="experience-info">
                                            <div><p><strong>Job Title:</strong> {v.jobTitle}</p></div>
                                            <div><p><strong>Employer:</strong> {v.title}</p></div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="experience-info">
                                            <div><p><strong>Start Date:</strong> {moment(v.startDate).format("MMMM YYYY")}</p></div>
                                            <div><p><strong>End Date:</strong> {v.endDate === null ? "Present" : moment(v.endDate).format("MMMM YYYY")}</p></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="experience-content">
                                    <div dangerouslySetInnerHTML={{ __html: v.content }}></div>
                                    {v.website !== null ?
                                        <div className="col website-info">
                                            <Link to={v.website} target="_blank" className="btn">Visit website</Link>
                                        </div> : ""
                                    }
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}